export enum GroupType {
  Product = 'PRODUCT',
  FieldAndMessage = 'FIELD_AND_MESSAGE',
  None = 'NONE',
}

export const getGroupType = (groupType: string): GroupType => {
  switch (groupType) {
    case GroupType.Product.toString():
      return GroupType.Product
    case GroupType.FieldAndMessage.toString():
      return GroupType.FieldAndMessage
    case GroupType.None.toString():
      return GroupType.None
    default:
      throw new Error(`Unknown GroupType: ${groupType}`)
  }
}
